import React, { useEffect, useState } from "react";

import { FiTwitter } from "react-icons/fi";

import { motion } from "framer-motion";
import { ExternalLink } from "./Helpers/TwitterLink";
import { Highlight } from "./Helpers/Highlight";
import { twMerge } from "tailwind-merge";

let interval: any;

export const AnimatedTestimonials = ({ className }: any) => {
  const cards = [
    {
      id: 0,
      name: "Kevin Newman",
      designation: "Founder of LegendCV",
      avatar: "/testimonials/kevin.png",
      content: (
        <div>
          Moonbeam has beamed my writing output to the moon. Now with the new
          feature of adding your notes to get a coherent piece of writing
          started, it&apos;s a critical part of my workflow! Best tool out
          there!
        </div>
      ),
    },
    {
      id: 1,
      name: "Ciara",
      designation: "College Student",
      avatar: "/testimonials/ciara.png",
      content: (
        <div>
          I&apos;ve turned in so many assignments using moonbeam. Gets me
          A&apos;s with no plagiarism. the AI does such a good job of creating
          authentic sentences with researched points specially curated for your
          target audience. there&apos;s nothing at this level yet on the market
        </div>
      ),
    },
    {
      id: 2,
      name: "Ahmed Khalil",
      designation: "@ahmedadly",
      avatar: "/testimonials/ahmed.png",
      content: (
        <div>
          Started using{" "}
          <ExternalLink link="https://app.gomoonbeam.com">
            gomoonbeam.com
          </ExternalLink>{" "}
          by{" "}
          <ExternalLink link="https://twitter.com/johnbuilds">
            @johnbuilds
          </ExternalLink>{" "}
          to explore different ideas for content for{" "}
          <ExternalLink className="https://twitter.com/blazihq">
            @BlaziHQ
          </ExternalLink>{" "}
          products, and it&apos;s really a very useful tool if you want to
          curate any content, <Highlight>highly recommended!</Highlight>
        </div>
      ),
    },
    {
      id: 3,
      name: "Leo Mills",
      designation: "@Leonardo_Mills",
      avatar: "/testimonials/leo.png",
      content: (
        <div>
          <ExternalLink link="https://twitter.com/johnbuilds">
            @johnbuilds
          </ExternalLink>{" "}
          Bro... this Moonbeam app is sick. Been using it for just 5 minutes
          after seeing your tweet pop up on my feed and it&apos;s powerful.
          Great for the online coach/content creator community{" "}
          <ExternalLink link="https://app.gomoonbeam.com">
            gomoonbeam.com
          </ExternalLink>{" "}
        </div>
      ),
    },
    {
      id: 4,
      name: "Brian Albrecht",
      designation: "@BrianCAlbrecht",
      avatar: "/testimonials/brian.png",
      content: (
        <div>
          Research is not 100% about the full-length paper. Often we write
          shorter pieces for a wider audience.
          <ExternalLink link="https://app.gomoonbeam.com">
            @gomoonbeam
          </ExternalLink>{" "}
          helps outline an essay from prompts you give. A few more prompts and,
          boom, the start of an essay. Yes, your students are going to use this.
          But you can too!
        </div>
      ),
    },
    {
      id: 5,
      name: "Your Textbook Geek",
      designation: "@for_higher_ed",
      avatar: "/testimonials/your-textbook-geek.png",
      content: (
        <div>
          I just got done writing a chapter for a fintech training using{" "}
          <ExternalLink link="https://app.gomoonbeam.com">
            @gomoonbeam
          </ExternalLink>
          . I&apos;ve used Jasper in the past - it&apos;s good, but moonbeam
          seems to work with me better.
        </div>
      ),
    },
  ];

  const [currentCard, setCurrentCard] = useState(cards[0]);

  useEffect(() => {
    if (currentCard) {
      startFlipping();
    }

    return () => clearInterval(interval);
  }, []);

  const startFlipping = () => {
    interval = setInterval(() => {
      setCurrentCard(
        (currentCard) => cards[(currentCard.id + 1) % cards.length]
      );
    }, 8000);
  };
  return (
    <div
      onMouseEnter={() => clearInterval(interval)}
      onMouseLeave={() => startFlipping()}
      className={twMerge(
        "flex max-w-sm w-full mx-auto flex-col justify-start items-start mt-20 md:mt-0 mb-16 relative h-36",
        className
      )}
    >
      <div className="absolute border rounded-md transform scale-[.85] -top-9 h-full w-full z-10 dark:border-slate-800"></div>
      <div className="absolute border rounded-md transform scale-90 -top-6 h-full w-full z-20 backdrop-blur-sm dark:border-slate-800">
        <span className="absolute h-px -top-px inset-x-4 bg-gradient-to-r from-teal-500/0 via-teal-500/40 to-teal-500/0 dark:from-teal-400/0 dark:via-teal-400/40 dark:to-teal-400/0"></span>
      </div>
      <div className="absolute border rounded-md transform scale-95 -top-3 h-full w-full z-30 backdrop-blur-sm dark:border-slate-800"></div>

      <TwitterCard card={currentCard} />
    </div>
  );
};

const TwitterCard = ({ card }: any) => {
  const dropIn = {
    hidden: {
      y: "0vh",
      x: "-4vw",
      //   scale: 1.2,
      opacity: 0,
    },
    visible: {
      y: "0",
      x: "0",
      //   scale: 1,
      opacity: 1,
    },
    exit: {
      x: "4vw",
      opacity: 0,
    },
  };
  return (
    <motion.div
      variants={dropIn}
      initial="hidden"
      animate="visible"
      exit="exit"
      key={card.id}
      className=" rounded-lg px-8 py-4 border border-slate-200 dark:border-slate-700 z-50 relative bg-white dark:bg-zinc-900 flex flex-col items-start"
    >
      <span className="absolute w-[40%] -bottom-px right-px h-px bg-gradient-to-r from-blue-500/0 via-blue-500/40 to-blue-500/0 dark:from-blue-400/0 dark:via-blue-400/40 dark:to-blue-400/0"></span>
      <span className="absolute w-px -left-px h-[40%] bg-gradient-to-b from-blue-500/0 via-blue-500/40 to-blue-500/0 dark:from-blue-400/0 dark:via-blue-400/40 dark:to-blue-400/0"></span>
      <div className="flex justify-between items-start w-full">
        <div className="flex flex-row space-x-4 items-start ">
          <img
            src={card.avatar}
            alt="avatar"
            className="w-8 h-8 object-cover rounded-full shadow"
          />
          <div className="flex flex-col items-start justify-start ">
            <p className="text-sm font-semibold text-zinc-700 ">{card.name}</p>
            <p className="text-zinc-500 text-xs ">{card.designation}</p>
          </div>
        </div>
        <FiTwitter className="text-blue-500 inline-block" />
      </div>
      <div className="mt-4">
        <div className="text-gray-700 dark:text-slate-300 text-sm">
          {card.content}
        </div>
      </div>
    </motion.div>
  );
};
